module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-banner-3@1x-550d196b91e917d1905ecd5a1e6c02b8.png";